import { AutoMap } from "@automapper/classes";
import { BaseDOM } from "../base.dom";

export class ZoneCompare extends BaseDOM<ZoneCompare> {
    @AutoMap()
    /** Really needed to delete ZoneCompare as it's only managed in the client */
    Id?: number;

    @AutoMap()
    Code: string = ''
    @AutoMap()
    Name: string = ''
    @AutoMap()
    DifferentielPression?: number
    @AutoMap()
    ProtectionEnvironnement: boolean = false
}